import React, {useState} from 'react';
import {Button, Col, Form, Input, InputNumber, Modal, Row, Select, Space, Typography} from "antd";
import {ClockCircleOutlined, MailOutlined, PlusOutlined, UserAddOutlined} from '@ant-design/icons';
import {useDispatch} from "react-redux";
import {createExtUserAction} from "../../_redux/actions/ExternalUserAction";

const MAX_EXPIRE_HOURS = 30 * 24;
const toExpireHours = (expireTime, type) => (type === 'day' ? expireTime * 24 : expireTime);

const ExternalUserAddModal = () => {
    const [form] = Form.useForm();
    const {Title} = Typography;
    const {Option} = Select;
    const [showModal, setShowModal] = useState(false);
    const dispatch = useDispatch();

    const openModal = () => {
        setShowModal(true)
    }

    const onClickSubmit = () => {
        form.validateFields().then((value) => {
            dispatch(createExtUserAction({
                "uploadUserEmail": value.email,
                "expireTime": toExpireHours(value.expireTime, value.type),
            }, setShowModal));
        })
    }

    const handleCancel = () => {
        setShowModal(false);
    }

    const selectAfter = (
        <Select style={{width: 80}}>
            <Option value="hour">Hours</Option>
            <Option value="day">Days</Option>
        </Select>
    )

    return (
        <>
            <div style={{textAlign: 'right', marginBottom: '1rem'}}>
                <Button style={{borderRadius: '0.5rem'}} onClick={openModal} icon={<PlusOutlined />}/>
            </div>
            <Modal
                title={<Title level={4} style={{margin: '0 0 2rem'}}><UserAddOutlined /> Add User</Title>}
                open={showModal}
                onCancel={handleCancel}
                afterClose={() => form.resetFields()}
                width={360}
                footer={null}
                maskClosable={false}
            >
                <Form form={form} onFinish={onClickSubmit} layout='vertical'>
                    <Row>
                        <Col span={24}>
                            <Form.Item label='E-mail' name='email' rules={[{required: true, message: 'Please Input'}]}>
                                <Input placeholder={'E-mail'} prefix={<MailOutlined />}/>
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item label='Upload Expire Time' name='expireTime' dependencies={['type']}
                                       rules={[
                                           {required: true, message: 'Please Input'},
                                           ({getFieldValue}) => ({
                                               validator(_, value) {
                                                   if (value == null || toExpireHours(value, getFieldValue('type')) <= MAX_EXPIRE_HOURS)
                                                       return Promise.resolve();
                                                   return Promise.reject(new Error('Max 30 days (720 hours)'));
                                               },
                                           }),
                                       ]}>
                                {/*<InputNumber style={{width: '100%'}} min={1} max={120} placeholder={'Hour (1 ~ 120)'} prefix={<ClockCircleOutlined />}/>*/}
                                <InputNumber style={{width: '100%'}} placeholder={'hours | days (max 30 days)'} prefix={<ClockCircleOutlined />} min={1} precision={0} addonAfter={<Form.Item initialValue='hour' noStyle name='type'>{selectAfter}</Form.Item>}/>
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item style={{marginBottom: '0.5rem'}}>
                                <Button style={{marginTop: '2rem', width: '100%', height: '2rem', borderRadius: '0.5rem'}} type='primary' htmlType='submit'>Save</Button>
                            </Form.Item>
                        </Col>

                    </Row>
                </Form>
            </Modal>

        </>
    );
};

export default ExternalUserAddModal;